import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "row q-mb-lg" };
const _hoisted_2 = {
    class: "material-icons topmenu-icon text-light-green-7",
    "aria-hidden": "true"
};
const _hoisted_3 = { class: "text-h6 text-bold indention" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_card = _resolveComponent("q-card");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu) => {
            return (_openBlock(), _createElementBlock("div", {
                key: menu.nameAttribute,
                class: "col-6 col-sm-4 col-md-3 col-lg-20per col-xl-20per q-pa-md"
            }, [
                _createVNode(_component_q_card, {
                    class: "cursor-pointer q-hoverable text-center",
                    onClick: ($event) => (_ctx.$router.push({ name: menu.nameAttribute }))
                }, {
                    default: _withCtx(() => [
                        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "q-focus-helper" }, null, -1)),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_2, _toDisplayString(menu.icon), 1),
                                _createElementVNode("div", _hoisted_3, _toDisplayString(menu.menuName), 1)
                            ]),
                            _: 2
                        }, 1024)
                    ]),
                    _: 2
                }, 1032, ["onClick"])
            ]));
        }), 128))
    ]));
}
